import React, { useState, useEffect } from 'react';
import HeroVideo from '../components/HeroVideo'
import CardBox from '../components/CardBox'
import CardLeft from '../components/Card'
import Cardright from '../components/Card-2'
import HeroContainer from '../components/HeroContainer'
import SliderDivisor from '../components/SwiperSlider'
import { Link } from 'react-router-dom'
import { ParallaxProvider, Parallax } from 'react-scroll-parallax';
import { Modal } from '../components/Modals';

export default function Home (){

    const [isMdOrLarger, setIsMdOrLarger] = useState(false);

    useEffect(() => {
      const handleResize = () => {
        setIsMdOrLarger(window.innerWidth >= 768); // md: 768px en Tailwind
      };
    
      handleResize(); // run once
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
    


    return(
      <div className="overflow-x-hidden w-full">
        <>
        <Modal fancy="cerrado.png"/>
        <ParallaxProvider>
           
        <HeroContainer img={'images/home-up.jpg'} text1="Estancia" text2="La Margarita"/>
       
        <div className="px-0 pt-20 md:pt-0 md:px-0">
          
        <CardBox>
        <div className="overflow-x-hidden w-full">
        <Parallax 
          translateX={isMdOrLarger ? [-10 , 10] : [0, 0]} // Solo escalar en md+
          translateY={isMdOrLarger ? [0 , -40] : [0, 0]} // Solo escalar en md+
        opacity={isMdOrLarger ? [0.9, 1.5] : [1, 0]} // Solo escalar en md+
         scale={isMdOrLarger ? [0.9, 1] : [1, 1]} // Solo escalar en md+
        easing="easeInQuad"
        >
        <CardLeft title="¡EXPERIENCIAS ÚNICAS EN UN LUGAR ÚNICO!" img="images/gallery/book3.jpg">"¡Bienvenidos a 'La Margarita'! Situada en un entorno rural idílico, nuestra estancia ofrece una escapada perfecta para aquellos que buscan desconectar de la rutina y sumergirse en la tranquilidad del campo.

                Con una capacidad para 500 personas, nuestras amplias instalaciones están diseñadas para satisfacer todas tus necesidades y deseos. 
        </CardLeft>
        </Parallax>
        </div>
        <div className="overflow-x-hidden w-full">
        <Parallax 
        translateX={isMdOrLarger ? [10 , -20] : [0, 0]} // Solo escalar en md+
        translateY={isMdOrLarger ? [0 , -40] : [0, 0]} // Solo escalar en md+
        opacity={isMdOrLarger ? [0.9, 1.5] : [1, 0]} // Solo escalar en md+
        scale={isMdOrLarger ? [0.9, 1] : [1, 1]} // Solo escalar en md+
        easing="easeInQuad"
        >
                <Cardright  title="Cada visita es una experiencia diferente." img="images/home/3.jpeg">En 'La Margarita', cada visita es una experiencia diferente. Ven y descubre la belleza y la serenidad de nuestro entorno natural, donde nuestras tradiciones se combinan con el confort moderno para ofrecerte una escapada inolvidable.

                ¡Te esperamos con los brazos abiertos para vivir momentos inolvidables en el corazón del campo!"
                </Cardright>
                </Parallax>
                </div>
                <div className="overflow-x-hidden w-full">
                <Parallax translateX={isMdOrLarger ? [-10 , 10] : [0, 0]} // Solo escalar en md+
                translateY={isMdOrLarger ? [0 , -10] : [0, 0]} // Solo escalar en md+
              opacity={isMdOrLarger ? [0.9, 1.5] : [1, 0]} // Solo escalar en md+
               scale={isMdOrLarger ? [0.9, 1] : [1, 1]} // Solo escalar en md+
              easing="easeInQuad">
         <CardLeft title="Delicias Rurales: Sabores Auténticos en La Margarita" img="images/home/7.jpeg"> En 'La Margarita', la experiencia culinaria es tan excepcional como el entorno que la rodea. Desde el desayuno hasta la merienda, cada comida es una celebración de sabores auténticos y platos tradicionales que deleitarán tus sentidos.

             Nuestros chefs expertos utilizan ingredientes frescos y locales para crear platos que reflejan la riqueza de la gastronomía argentina, garantizando así una experiencia culinaria inolvidable para todos nuestros huéspedes. Ven y únete a nosotros en la mesa, donde cada comida es una celebración de la vida y la amistad.
        </CardLeft>
        </Parallax>
        </div>
        
                     </CardBox>
                     </div>


                     <div className="mt-5 md:mt-0 md:p-0 ">
                     <SliderDivisor/>
                      
                     </div>
                     
                    <div className="px-0 md:px-0">
                     <CardBox>
            <div className="overflow-x-hidden w-full">
            <Parallax
          translateX={isMdOrLarger ? [-10 , 10] : [0, 0]} // Solo escalar en md+
          translateY={isMdOrLarger ? [0 , 0] : [0, 0]} // Solo escalar en md+
        opacity={isMdOrLarger ? [0.9, 1.5] : [1, 0]} // Solo escalar en md+
         scale={isMdOrLarger ? [0.9, 1] : [1, 1]} // Solo escalar en md+
        easing="easeInQuad">
        <CardLeft title="¡Actividades para Todos! Deportes y Entretenimiento" img="images/gallery/book4.jpg">En 'La Margarita', el deporte y el entretenimiento se entrelazan en un escenario vibrante y lleno de energía. Nuestro extenso terreno ofrece una variedad de opciones para que todos, desde los más competitivos hasta los que buscan relajarse, encuentren su actividad ideal. 
        </CardLeft>
        </Parallax>
        </div>
        <div className="overflow-x-hidden w-full">
        <Parallax
          translateX={isMdOrLarger ? [0 , -10] : [0, 0]} // Solo escalar en md+
          translateY={isMdOrLarger ? [0 , 0] : [0, 0]} // Solo escalar en md+
        opacity={isMdOrLarger ? [0.9, 1.5] : [1, 0]} // Solo escalar en md+
         scale={isMdOrLarger ? [0.9, 1] : [1, 1]} // Solo escalar en md+
        easing="easeInQuad">
                <Cardright  title="Sumérgete en la Diversión: Disfruta de Nuestra Refrescante Piscina" img="images/home/2.jpeg">¡En 'La Margarita', la diversión nunca se detiene, especialmente cuando te sumerges en nuestras refrescantes aguas! Nuestra piscina es el lugar perfecto para refrescarte y relajarte bajo el cálido sol del campo. Con un diseño cuidadosamente planificado y una atmósfera relajante, nuestra piscina ofrece un oasis de tranquilidad y diversión.
                
                <p className='italic text-sm py-2'> Piscina costo adicional. Precio actualizado en <Link to="/opcionales" className='hover:text-amber-500'>opcionales.</Link></p>
                </Cardright>
                </Parallax>
                </div>
                <div className="overflow-x-hidden w-full">
                <Parallax
          translateX={isMdOrLarger ? [-10 , 10] : [0, 0]} // Solo escalar en md+
          translateY={isMdOrLarger ? [0 , 0] : [0, 0]} // Solo escalar en md+
        opacity={isMdOrLarger ? [0.9, 1.5] : [1, 0]} // Solo escalar en md+
         scale={isMdOrLarger ? [0.9, 1] : [1, 1]} // Solo escalar en md+
        easing="easeInQuad"> 
         <CardLeft title="¡Entretenimiento en Vivo en 'La Margarita': Donde la Diversión Nunca Termina!" img="images/home/9.jpeg"> 
				Nuestro escenario se convierte en el centro de atención mientras los artistas locales y regionales deleitan a nuestros huéspedes con su talento y pasión. Desde música folclórica tradicional hasta éxitos contemporáneos, hay algo para todos los gustos y edades en nuestros espectáculos. 
				Ya sea que estés buscando una noche relajada bajo las estrellas o una fiesta animada con amigos y familiares, nuestros shows en vivo en 'La Margarita' son el complemento perfecto para tu escapada rural. ¡Prepárate para emocionarte, reír y aplaudir mientras disfrutas de la magia del entretenimiento en vivo en nuestro encantador refugio rural!"
        </CardLeft>
        </Parallax>
        </div>
                     </CardBox>
                    
             </div>
            
             <div>
                
             <div className='px-2 md:px-0'>
        <h2 className='md:font-peter font-montserrat text-xl p-10 md:text-5xl text-white text-center pt-10 md:pb-10 '> Sumérgete en la serenidad y deja que la naturaleza te abrace.</h2>
        <h1 className='font-peter text-4xl md:text-8xl  text-amber-500 text-center md:-rotate-3 pb-10'>Estancia La Margarita</h1>
        </div>
             </div>
             </ParallaxProvider>
        </>
      </div>
    )
};